import { CreateAppointmentPayload, TCreateAppointmentResponse } from './types';

import { AppointmentsGateway } from '../../../../services/http/appointments-gateway';
import { useGetTraveller } from '../useGetTraveller';
import { useMutation } from '@tanstack/react-query';
import { useOffice } from '../../../hooks/useOffice/useOffice';

const useCreateAppointment = () => {
  const office = useOffice();

  const { data: travellerData } = useGetTraveller({ isEnabled: false });

  const mutation = useMutation(
    async ({
      timezone,
      date,
      start,
      tid,
    }: {
      timezone: string;
      date: string;
      start: string;
      tid: number;
    }) => {
      const appointmentPayload: CreateAppointmentPayload = {
        eventId: Number(office.gCalendar.eventId),
        contact: {
          type: 'traveller',
          id: Number(travellerData?.result.cid),
          refField: 'tid',
          refFieldId: tid,
        },
        timezone,
        date,
        start,
      };

      return await AppointmentsGateway.post<TCreateAppointmentResponse>(
        `/public/booking/session`,
        appointmentPayload
      );
    }
  );

  return { mutation, isLoading: mutation.isLoading, error: mutation.error };
};

export { useCreateAppointment };
